import React from 'react';
import styled from 'styled-components';
import { HorizontalScrollWrapper } from '../../styledComponents/theme';
import HorizontalScrollEpisodeCard, { HorizontalScrollBlankEpisodeCard } from './HorizontalScrollEpisodeCard';

const HorizontalScrollEpisodeCards = ({episodes, tag}) => {
  let items = episodes[tag.id].map(episode => {
    if(episode) {
      return (
        <HorizontalScrollEpisodeCard episode={episode} key={episode.episodeId}/>
      );
    }
    return false
  });
  if(items.length < 3) {
    let i =0, max = 3-items.length;
    for (i; i < max; i++) {
      items.push(<HorizontalScrollBlankEpisodeCard key={items.length + i + 1}/>);
    }
  }
  return(
    <HorizontalScrollWrapper>
      {items}
    </HorizontalScrollWrapper>
  );

};
export default HorizontalScrollEpisodeCards;



// WEBPACK FOOTER //
// ./src/components/Episode/HorizontalScrollEpisodeCards.js